export const SCENARIO_TYPES = {
  EVENT: 'event',
  EMAIL: 'email',
  MESSAGE: 'message',
  DIALOGUE: 'dialogue',
};

export const SCORE_METRIC_TYPES = {
  PUBLIC_OPINION: 'update_public_opinion',
  STABILITY: 'update_stability',
  CREDIBILITY: 'update_credibility',
  NEGOTIATION: 'update_negotiation',
};

export const DOCUMENT_TYPES = {
  EMAIL: 'email',
  MESSAGE: 'message',
  DOCUMENT: 'document',
};

export const DEFAULT_PLAYER_SCORES = {
  [SCORE_METRIC_TYPES.PUBLIC_OPINION]: 50,
  [SCORE_METRIC_TYPES.STABILITY]: 50,
  [SCORE_METRIC_TYPES.NEGOTIATION]: 50,
  [SCORE_METRIC_TYPES.CREDIBILITY]: 50,
};

export const SCORE_METRIC_NAMES = {
  [SCORE_METRIC_TYPES.PUBLIC_OPINION]: 'Public Opinion',
  [SCORE_METRIC_TYPES.STABILITY]: 'Stability',
  [SCORE_METRIC_TYPES.NEGOTIATION]: 'Negotiation',
  [SCORE_METRIC_TYPES.CREDIBILITY]: 'Credibility',
};

export const SCENARIO_REQUIREMENTS_TYPES = {
  PUBLIC_OPINION_LESS_THAN: 'public_opinion_is_less_than',
  PUBLIC_OPINION_MORE_THAN: 'public_opinion_is_more_than',
  STABILITY_LESS_THAN: 'stability_is_less_than',
  STABILITY_MORE_THAN: 'stability_is_more_than',
  CREDIBILITY_LESS_THAN: 'credibility_is_less_than',
  CREDIBILITY_MORE_THAN: 'credibility_is_more_than',
  NEGOTIATION_LESS_THAN: 'negotiation_is_less_than',
  NEGOTIATION_MORE_THAN: 'negotiation_is_more_than',
  TIME_LESS_THAN: 'time_is_less_than',
  TIME_MORE_THAN: 'time_is_more_than',
  SCENARIO_CHOICE: 'scenario_choice',
  REPEATABLE: 'repeatable',
};

export const OPERATOR_TYPES = {
  MORE_THAN: 'more_than',
  LESS_THAN: 'less_than',
};

export const SCENARIO_REQUIREMENTS_METRICS = {
  [SCENARIO_REQUIREMENTS_TYPES.PUBLIC_OPINION_LESS_THAN]: {
    type: SCORE_METRIC_TYPES.PUBLIC_OPINION,
    operator: OPERATOR_TYPES.LESS_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.PUBLIC_OPINION_MORE_THAN]: {
    type: SCORE_METRIC_TYPES.PUBLIC_OPINION,
    operator: OPERATOR_TYPES.MORE_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.STABILITY_LESS_THAN]: {
    type: SCORE_METRIC_TYPES.STABILITY,
    operator: OPERATOR_TYPES.LESS_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.STABILITY_MORE_THAN]: {
    type: SCORE_METRIC_TYPES.STABILITY,
    operator: OPERATOR_TYPES.MORE_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.CREDIBILITY_LESS_THAN]: {
    type: SCORE_METRIC_TYPES.CREDIBILITY,
    operator: OPERATOR_TYPES.LESS_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.CREDIBILITY_MORE_THAN]: {
    type: SCORE_METRIC_TYPES.CREDIBILITY,
    operator: OPERATOR_TYPES.MORE_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.NEGOTIATION_LESS_THAN]: {
    type: SCORE_METRIC_TYPES.NEGOTIATION,
    operator: OPERATOR_TYPES.LESS_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.NEGOTIATION_MORE_THAN]: {
    type: SCORE_METRIC_TYPES.NEGOTIATION,
    operator: OPERATOR_TYPES.MORE_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.TIME_LESS_THAN]: {
    type: 'time',
    operator: OPERATOR_TYPES.LESS_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.TIME_MORE_THAN]: {
    type: 'time',
    operator: OPERATOR_TYPES.MORE_THAN,
  },
  [SCENARIO_REQUIREMENTS_TYPES.SCENARIO_CHOICE]: {
    type: 'scenario_choice',
  },
  [SCENARIO_REQUIREMENTS_TYPES.REPEATABLE]: {
    type: 'repeatable',
  },
};

export const TIMELINE_BY_ID = {
  0: {
    time: '09:00',
    prefix: 'am',
  },
  1: {
    time: '10:00',
    prefix: 'am',
  },
  2: {
    time: '11:00',
    prefix: 'am',
  },
  3: {
    time: '12:00',
    prefix: 'pm',
  },
  4: {
    time: '13:00',
    prefix: 'pm',
  },
  5: {
    time: '14:00',
    prefix: 'pm',
  },
  6: {
    time: '15:00',
    prefix: 'pm',
  },
  7: {
    time: '16:00',
    prefix: 'pm',
  },
  8: {
    time: '17:00',
    prefix: 'pm',
  },
  9: {
    time: '18:00',
    prefix: 'pm',
  },
  10: {
    time: '19:00',
    prefix: 'pm',
  },
  11: {
    time: '20:00',
    prefix: 'pm',
  },
  12: {
    time: '21:00',
    prefix: 'pm',
  },
  13: {
    time: '22:00',
    prefix: 'pm',
  },
  14: {
    time: '23:00',
    prefix: 'pm',
  },
  15: {
    time: '00:00',
    prefix: 'am',
  },
};

export const OUTRO_STATES = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
};

export const OUTRO_STATE_VALUES = {
  [OUTRO_STATES.SUCCESS]: {
    title: 'Negotiation complete!',
    colour: 0x00a83b,
    header_image: 'background_header_win',
    panels: {
      panel_1: 'outro_1_success',
      panel_2: 'outro_2',
    },
  },
  [OUTRO_STATES.FAIL]: {
    title: 'Negotiation failed!',
    header_image: 'background_header_fail',
    colour: 0xa61780,
    panels: {
      panel_1: 'outro_1_fail',
      panel_2: 'outro_2',
    },
  },
};
